export interface GapCalculatorInterface {
  vehiclePurchasePrice?: number;
  claimLimit?: number;
  vehicleRegDate: string;
  insTerm: number;
}

export class GapCalculator implements GapCalculatorInterface {
  vehiclePurchasePrice?: number;
  claimLimit?: number;
  vehicleRegDate: string;
  insTerm: number;

  constructor() {
    this.vehicleRegDate = null;
    this.insTerm = null;
  }
}
